import { usePositionStore } from "@/store/pinia/position";
import { computed } from "vue";

export function useReadinessOrganization() {
  const positionStore = usePositionStore();

  const allPositions = computed(() => positionStore.positions);

  const loadAllPositions = async (queryParams) => {
    await positionStore.loadPositions(queryParams);
  };
  return {
    allPositions,
    loadAllPositions,
  };
}
